module.exports = __webpack_public_path__ + "static/media/menu-administrar.efbdbcc5.svg";